export default {
  fahrdienstTypes: [],
  verkehrsPeriodenKalender: [],
  additionalFahrdienstDays: [],
  cancelledFahrdienstDays: [],

  infoFileTypeByInstance: {},
  fahrdienstLines: [],
  reportFiles: [],
};
